import { post } from "@/utils/utils";

const messageCenter = {
  state: {},
  mutations: {
    ADD_WX_MSG_SEND_RULE() {},
    WX_MSG_SEND_RULE_LIST() {},
    EDIT_WX_MSG_SEND_RULE() {},
    MATCHING_ROBOT() {},
    ADD_WX_ROBOT_INFO() {},
    ADD_WX_MSG_TEMP_INFO() {},
    QUERY_ROBOT_KEY_WORD() {},
    WX_ROBOT_LIST() {},
    EDIT_WX_ROBOT_INFO() {},
    WX_GROUP_INFO_LIST() {},
    WX_ACCOUNT_INFO_LIST() {},
    WX_GROUP_LIST() {},
    DEL_GROUP_INFO() {},
    QUERY_WX_GROUP_INFO_DETAILS() {},
    EDIT_GROUP_INFO() {},
    WX_MSG_TEMP_INFO_LIST() {},
    EDIT_WX_MSG_TEMP_INFO() {},
    SYNCHRO_GROUP() {},
    QUERY_WX_GROUP_INFO_DETAILS_NEW() {},
    EDIT_GROUP_INFO_NEW() {},
    IMPORT_GROUP() {},
  },
  actions: {
    addWxMsgSendRule({ commit }, params) {
      return post({
        commit,
        url: `/signed/wxMsgSendRule/add`,
        name: "ADD_WX_MSG_SEND_RULE",
        params
      });
    },
    queryWxMsgSendRuleList({ commit }, params) {
      return post({
        commit,
        url: `/signed/wxMsgSendRule/list`,
        name: "WX_MSG_SEND_RULE_LIST",
        params
      });
    },
    editWxMsgSendRule({ commit }, params) {
      return post({
        commit,
        url: `/signed/wxMsgSendRule/edit`,
        name: "EDIT_WX_MSG_SEND_RULE",
        params
      });
    },
    matchingRobot({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/matchingRobot`,
        name: "MATCHING_ROBOT",
        params
      });
    },
    addWxRobotInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/add`,
        name: "ADD_WX_ROBOT_INFO",
        params
      });
    },
    addWxMsgTemplateInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/addWxMsgTemplateInfo`,
        name: "ADD_WX_MSG_TEMP_INFO",
        params
      });
    },
    queryRobotKeyWord({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/queryKeyWord`,
        name: "QUERY_ROBOT_KEY_WORD",
        params
      });
    },
    queryWxRobotInfoList({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/list`,
        name: "WX_ROBOT_LIST",
        params
      });
    },
    editWxRobotInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/edit`,
        name: "EDIT_WX_ROBOT_INFO",
        params
      });
    },
    queryGroupInfoList({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/queryGroupInfoList`,
        name: "WX_GROUP_INFO_LIST",
        params
      });
    },
    queryAccountInfoList({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/queryAccountInfoList`,
        name: "WX_ACCOUNT_INFO_LIST",
        params
      });
    },
    queryGroupList({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/groupInfoList`,
        name: "WX_GROUP_LIST",
        params
      });
    },
    delGroupInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/delGroupInfo`,
        name: "DEL_GROUP_INFO",
        params
      });
    },
    importGroup({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/import`,
        name: "IMPORT_GROUP",
        params
      });
    },
    queryWxGroupInfoDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/queryWxGroupInfoDetails`,
        name: "QUERY_WX_GROUP_INFO_DETAILS",
        params
      });
    },
    editGroupInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/editGroupInfo`,
        name: "EDIT_GROUP_INFO",
        params
      });
    },
    queryWxMsgTemplateInfoList({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/queryWxMsgTemplateInfoList`,
        name: "WX_MSG_TEMP_INFO_LIST",
        params
      });
    },
    editWxMsgTemplateInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/editWxMsgTemplateInfo`,
        name: "EDIT_WX_MSG_TEMP_INFO",
        params
      });
    },
    synchroGroup({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/synchroGroup`,
        name: "SYNCHRO_GROUP",
        params
      });
    },
    queryWxGroupInfoDetailsNew({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/queryWxGroupInfoDetailsNew`,
        name: "QUERY_WX_GROUP_INFO_DETAILS_NEW",
        params
      });
    },
    editGroupInfoNew({ commit }, params) {
      return post({
        commit,
        url: `/store/wxRobotInfo/editGroupInfoNew`,
        name: "EDIT_GROUP_INFO_NEW",
        params
      });
    },
  }
};

export default messageCenter;
